function getFocusableElements(container) {
  if(container){
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
}

const onmouseleaveHandeler = (e) => {
  if(e.classList.contains('variant_image_active')) {
    e.classList.remove('variant_image_active');
  }
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if(window.innerWidth > 750){
    if(summary.closest('header-menu')){
      summary.closest('details').addEventListener('mouseenter', (event) => {
        const detailsElement = event.currentTarget;
          if (!detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.setAttribute('open', 'true');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'true');
          }
        
      });
      
      summary.closest('details').addEventListener('mouseleave', (event) => {
        const detailsElement = event.currentTarget;
          if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.removeAttribute('open');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'false');
          }
      });
    }
  }
  
  summary.addEventListener('click', (event) => {
    
    if (summary.classList.contains('matat_filters__summary')) {
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".matat-filter-body details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }

      const sliderWrapper = document.getElementById('matat-range-slider');
        if (sliderWrapper.rangeable) {
          sliderWrapper.rangeable.destroy?.(); // Optional chaining
          sliderWrapper.style.display = 'none';
          sliderWrapper.offsetHeight; // force reflow
          sliderWrapper.style.display = '';
          MatatFiltersForm.priceRangeSlider(); // re-init
        }
      
      }
      if(summary.closest('.product__accordion')){ 
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
      }
     if(document.querySelector(".header__search details").hasAttribute("open")){
        document.querySelector(".header__search details").removeAttribute("open")
      }
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    // Post to the iframe's own origin instead of '*' so the pause command only
    // reaches the trusted video frame. Derived from the iframe src, so it works
    // for youtube.com and youtube-nocookie.com; '*' only as a last-resort fallback.
    let targetOrigin = '*';
    try { targetOrigin = new URL(video.src, window.location.href).origin; } catch (e) {}
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', targetOrigin);
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    let targetOrigin = '*';
    try { targetOrigin = new URL(video.src, window.location.href).origin; } catch (e) {}
    video.contentWindow.postMessage('{"method":"pause"}', targetOrigin);
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    if (this.getAttribute('loaded')) {
      const deferredElement = this.querySelector('video, model-viewer, iframe');
      if (deferredElement && deferredElement.nodeName === 'VIDEO') deferredElement.play();
    } else if (this.dataset.autoplay) {
      this.loadContent(false);
    }
  }

  loadContent(focus = true) {
    if (focus) window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

/**
 * Flickity options for a product media viewer.
 *
 * Below 750px the theme deliberately runs the main gallery with page dots and no arrows (see the
 * `window.innerWidth < 750` block near the end of this file), which differs from the desktop
 * `data-flickity` config. Anything that re-initialises the gallery — the colour swap,
 * media-gallery.js — has to ask for the options here, otherwise re-initialising on mobile
 * silently drops the dots.
 */
function productGalleryFlickityOptions(element) {
  if (!element) return null;
  const isMainProductViewer =
    element.classList.contains('contains-media') && !element.closest('.gift-card-single-main-product');

  if (window.innerWidth < 750 && isMainProductViewer) {
    return {
      imagesLoaded: true,
      rightToLeft: true,
      cellAlign: 'right',
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
    };
  }

  const raw = element.getAttribute('data-flickity');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}
window.productGalleryFlickityOptions = productGalleryFlickityOptions;

/**
 * Fold a colour name to a comparison key.
 *
 * Hebrew colour names are written with a geresh (בז׳ U+05F3) in the option value but with a
 * plain apostrophe (בז' U+0027) in image ALT text — the migration sync writes one, the admin
 * the other — and the two are different characters, so a literal compare finds nothing and the
 * gallery falls back to showing every colour. Mirrors the `replace` chain in the Liquid.
 */
function normalizeColorKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[׳’ʼ]/g, "'")
    .replace(/[״”]/g, '"');
}
window.normalizeColorKey = normalizeColorKey;

/**
 * Colour-split collection cards: show the clicked colour's images in the card slider.
 *
 * ONLY the images change — title, price and links stay exactly as rendered.
 *
 * The grid already rendered one card per colour, each holding the exact image set the server
 * produced for its colour, so we take the media from the card that owns the requested colour.
 * Guessing an image from the variant data instead is what causes wrong-colour photos: plenty of
 * variants have no image assigned in Shopify, so the previous colour's photo simply stays.
 *
 * Cards are read from a pristine snapshot, not from live DOM: once a card's media has been
 * swapped it no longer represents its original colour, so switching back would find no source.
 * Every card of the product is snapshotted before the first swap.
 *
 * Only the id-free .card__media subtree is copied, so no duplicate DOM ids are introduced.
 */
const _colorCardSnapshots = new WeakMap();

// Matches the card slider options used on page load (see the DOMContentLoaded init below), so a
// re-initialised carousel keeps the same arrows, dots and RTL direction.
const CARD_SLIDER_FLICKITY_OPTIONS = {
  imagesLoaded: true,
  rightToLeft: true,
  cellAlign: 'right',
  pageDots: true,
  wrapAround: true,
  draggable: true,
  prevNextButtons: true,
};

/**
 * Markup for a card's media with Flickity's runtime additions undone.
 *
 * By the time a swatch is clicked the source card's carousel is already initialised, so its DOM
 * holds a .flickity-viewport wrapper, absolutely-positioned cells and injected nav buttons.
 * Copying that verbatim and re-initialising Flickity on top double-wraps the slider and the card
 * renders blank, so put the cells back as plain children and drop everything Flickity added.
 */
function pristineMediaHTML(media) {
  const clone = media.cloneNode(true);

  clone.querySelectorAll('.flickity-viewport').forEach((viewport) => {
    const slider = viewport.querySelector('.flickity-slider');
    if (slider) {
      while (slider.firstChild) viewport.parentNode.insertBefore(slider.firstChild, viewport);
    }
    viewport.remove();
  });

  clone.querySelectorAll('.flickity-button, .flickity-page-dots').forEach((el) => el.remove());

  clone.querySelectorAll('.flickity-enabled').forEach((el) => {
    el.classList.remove('flickity-enabled', 'is-draggable', 'is-fullscreen');
    el.removeAttribute('tabindex');
    el.removeAttribute('style');
  });

  clone.querySelectorAll('.pro-media').forEach((cell) => {
    cell.classList.remove('is-selected');
    cell.removeAttribute('style');
    cell.removeAttribute('aria-hidden');
    cell.removeAttribute('tabindex');
  });

  return clone.innerHTML;
}

function snapshotColorCards(productId) {
  document
    .querySelectorAll(`.product-card-wrapper[data-color-card="true"][data-product-id="${productId}"]`)
    .forEach((card) => {
      if (_colorCardSnapshots.has(card)) return;
      const media = card.querySelector('.card__media');
      _colorCardSnapshots.set(card, {
        // Taken before anything is swapped, so this is the card's original colour.
        colour: card.dataset.color,
        mediaHTML: media ? pristineMediaHTML(media) : null,
        mediaClass: media ? media.className : null,
      });
    });
}

/**
 * Rebuild a card's media from the per-colour payload the grid emits when a colour facet is
 * active. Mirrors the slider markup in card-product.liquid: one 460px src per cell, no srcset.
 */
function renderColorMediaFromPayload(card, colour, existingFlickity) {
  const script = document.querySelector(
    `script.matat-color-media[data-product-id="${card.dataset.productId}"]`
  );
  if (!script) return false;

  let payload;
  try {
    payload = JSON.parse(script.textContent);
  } catch (error) {
    return false;
  }

  const entries = payload[normalizeColorKey(colour)];
  const mediaInner = card.querySelector('.card__media .media');
  if (!entries || !entries.length || !mediaInner) return false;

  const link = card.querySelector('.card__heading a');
  const href = link ? link.getAttribute('href') : '';
  const alt = link ? link.textContent.trim() : '';
  const attr = (value) =>
    String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const cells = entries
    .map(
      (entry, index) =>
        `<div class="pro-media" data-index="${index}">` +
        `<a href="${attr(href)}" class="product-card-link">` +
        `<img src="${attr(entry[0])}" alt="${attr(alt)}" class="motion-reduce variant_image_element"` +
        ` width="${Number(entry[1]) || ''}" height="${Number(entry[2]) || ''}" loading="lazy">` +
        `</a></div>`
    )
    .join('');

  if (existingFlickity) existingFlickity.destroy();
  mediaInner.innerHTML = `<div class="flickity_grid flikity_grid_image slider">${cells}</div>`;
  return true;
}

function applyColorToCard(card, colour) {
  if (!card || card.dataset.colorCard !== 'true' || !colour) return false;
  if (card.dataset.shownColor === colour) return true;

  snapshotColorCards(card.dataset.productId);

  let source = null;
  document
    .querySelectorAll(`.product-card-wrapper[data-color-card="true"][data-product-id="${card.dataset.productId}"]`)
    .forEach((candidate) => {
      const snap = _colorCardSnapshots.get(candidate);
      if (snap && snap.colour === colour) source = snap;
    });

  const media = card.querySelector('.card__media');
  if (!media) return true;

  const grid = media.querySelector('.flickity_grid, .flikity_grid_image');
  const flkty = grid && typeof Flickity !== 'undefined' ? Flickity.data(grid) : null;

  if (source && source.mediaHTML !== null) {
    if (flkty) flkty.destroy();
    media.innerHTML = source.mediaHTML;
    if (source.mediaClass) media.className = source.mediaClass;
  } else if (!renderColorMediaFromPayload(card, colour, flkty)) {
    // Neither a sibling card nor a payload for this colour — leave the current images alone
    // rather than borrowing another colour's.
    return true;
  }

  // Re-init the card carousel so swiping only ever walks this colour's images.
  const newGrid = media.querySelector('.flickity_grid, .flikity_grid_image');
  if (newGrid && newGrid.querySelectorAll('.pro-media').length > 1 && typeof Flickity !== 'undefined') {
    const newFlkty = new Flickity(newGrid, CARD_SLIDER_FLICKITY_OPTIONS);
    // Keep the 3-dot cap this theme applies to card sliders (see matatCapCardSliderDots).
    if (typeof window.matatCapCardSliderDots === 'function') {
      window.matatCapCardSliderDots(newFlkty);
      newFlkty.on('change', function () { window.matatCapCardSliderDots(newFlkty); });
    }
  }

  card.dataset.shownColor = colour;
  return true;
}

// Swap a product card's media to the image bound to a selected variant/colour.
// Shared by the quick-add `color_change` path and the quick-add-disabled swatch click,
// so both switch the image identically. `variant_image` is a variant featured-media URL.
function swapCardMediaToImage(wrapper, variant_image) {
  const cardMedia = wrapper ? wrapper.querySelector('.card__media') : null;
  if (!cardMedia || !variant_image) return;
  // Match images by path WITHOUT query string OR file extension, so width / format(webp) /
  // version differences can never break the lookup.
  const normalize = (url) => (url || '').split('?')[0].replace(/^https?:/, '').replace(/\.(jpe?g|png|webp|gif|avif)$/i, '');
  const wantPath = normalize(variant_image);
  let targetMedia = null;
  cardMedia.querySelectorAll('.pro-media').forEach((pm) => {
    const img = pm.querySelector('img');
    if (img && normalize(img.getAttribute('src')) === wantPath) targetMedia = pm;
  });
  const grid = cardMedia.querySelector('.flickity_grid, .flikity_grid_image');
  const flkty = grid ? Flickity.data(grid) : null;
  if (flkty && targetMedia && targetMedia.dataset.index != null) {
    // Working slider (e.g. collection page): slide to the variant image.
    flkty.select(Number(targetMedia.dataset.index));
  } else {
    // No active Flickity instance (homepage, or single-image card): swap the visible image directly.
    const firstImg = cardMedia.querySelector('img.variant_image_element');
    if (firstImg) {
      const sized = variant_image + (variant_image.indexOf('?') > -1 ? '&' : '?') + 'width=460&format=webp';
      firstImg.src = sized;
      firstImg.srcset = sized;
    }
  }
  wrapper.classList.add('variant_image_active');
}

document.body.addEventListener('click', function (e) {
    let target = e.target;
    if(target.classList.contains('custom_variation_button')) {
      const cardWrapper = target.closest('.product-card-wrapper');
      // A colour card names its colour in the heading and links to that colour's variant, so
      // when another colour is picked inside the card those have to follow the price and images
      // below — otherwise the card would show one colour's photos under another's name. Done
      // BEFORE applyColorToCard because the payload path reads the heading link for its hrefs.
      if (cardWrapper && cardWrapper.dataset.colorCard === 'true') {
        const pickedLabel = target.closest('label');
        const pickedUrl = pickedLabel ? pickedLabel.getAttribute('data-variant-url') : null;
        const headingLink = cardWrapper.querySelector('.card__heading a');
        if (headingLink && pickedUrl) headingLink.setAttribute('href', pickedUrl);
        const colorLabelEl = cardWrapper.querySelector('.card__heading-color');
        if (colorLabelEl) colorLabelEl.textContent = ` - ${target.value}`;
      }
      // Colour cards rebuild their media from the grid. The variant plumbing below still runs so
      // price, badge and size availability stay in step; only the legacy image guessing is
      // skipped (see the `color_change` listener in VariantSelects).
      applyColorToCard(cardWrapper, target.value);
      if (cardWrapper) {
        const find_quick_btn = cardWrapper.querySelector("modal-opener");
        if(find_quick_btn){
          const updated_url = target.closest("label")?.getAttribute("data-variant-url");
          if (updated_url) find_quick_btn.querySelector("button")?.setAttribute('data-product-url', updated_url);
        }
        // Update the card price (incl. compare-at / on-sale state) for the selected colour.
        // The swatch carries the server-formatted money strings, so the format always
        // matches the card's own price snippet.
        const swatchLabel = target.closest('label');
        const cardPriceEl = cardWrapper.querySelector('.card__information .price');
        if (swatchLabel && cardPriceEl) {
          const priceStr = swatchLabel.getAttribute('data-variant-price');
          const compareStr = swatchLabel.getAttribute('data-variant-compare');
          const onSale = swatchLabel.getAttribute('data-variant-on-sale') === 'true';
          if (priceStr) {
            cardPriceEl.querySelectorAll('.change-price').forEach((el) => { el.innerHTML = priceStr; });
            const compareEl = cardPriceEl.querySelector('.price__sale s.price-item--regular');
            if (compareEl && compareStr) compareEl.innerHTML = compareStr;
            cardPriceEl.classList.toggle('price--on-sale', onSale);
          }
          // Keep the sale badge (percent off) in sync with the selected colour. The label
          // carries the server-rendered badge text so the discount always matches this variant.
          const saleBadge = cardWrapper.querySelector('.badge-main-matat .badge-matat.sale');
          if (saleBadge) {
            const badgeLabel = swatchLabel.getAttribute('data-variant-badge-label');
            if (onSale && badgeLabel) {
              saleBadge.textContent = badgeLabel;
              saleBadge.classList.add('is-sale');
              saleBadge.style.display = '';
            } else {
              saleBadge.classList.remove('is-sale');
              saleBadge.style.display = 'none';
            }
          }
        }
        const inlineVariation = cardWrapper.querySelector('.product-card_inline-variation');
        const parentItem = inlineVariation ? inlineVariation.querySelector('.product-form__input.listen_color_change') : null;
        if (parentItem) {
          // Match by exact value; CSS.escape guards color names containing quotes/special characters.
          const escVal = (window.CSS && CSS.escape) ? CSS.escape(target.value) : target.value.replace(/"/g, '\\"');
          let actual_var_item = parentItem.querySelector('[value="' + escVal + '"]')
            || Array.from(parentItem.querySelectorAll('input')).find((i) => i.value === target.value);
          if (actual_var_item) {
            actual_var_item.checked = true;
            parentItem.dispatchEvent(new CustomEvent('color_change', { 'detail': target.value }));
            actual_var_item.dispatchEvent(new Event('custom_change'));
          }
        } else if (!inlineVariation && cardWrapper.dataset.colorCard !== 'true') {
          // Quick add is disabled, so the inline variant/image machinery isn't rendered.
          // Switch the card image directly from the swatch's variant featured-media.
          // Colour cards are excluded: applyColorToCard() above already installed the exact
          // image set the server rendered for that colour.
          const variantImage = swatchLabel ? swatchLabel.getAttribute('data-variant-featured-media') : null;
          if (variantImage) swapCardMediaToImage(cardWrapper, variantImage);
        }
      }
    }
    if(target.closest('variant-radios') && target.closest('.product-card-wrapper')) {
      if(target.tagName.toUpperCase() == 'INPUT') {
        target.closest('variant-radios').dispatchEvent(new Event('change'));
      }
    }
});
/**
 * Declarative Flickity sliders (`data-flickity` / `data-flickity-responsive`).
 *
 * Both libraries auto-initialise ONCE and only once — Flickity on DOM ready, flickity-responsive
 * at script-parse time — so a section that enters the DOM later never becomes a carousel. In the
 * theme editor every settings change re-renders the section, which is why the featured-collection
 * row collapses to bare .slider__slide items until you click a different section: only
 * shopify:section:select was wired up, in theme-editor.js, which the home page doesn't even load.
 *
 * The window-load pass also repairs the storefront race. The slider stylesheets are requested
 * non-blocking (media="print" onload="this.media='all'"), so Flickity can measure its cells
 * before their widths exist and lock in a wrong layout — the same class of bug the inline cell
 * margin in theme.liquid was added to avoid. Re-measuring once after load is cheap and fixes it.
 *
 * The product media gallery is skipped: media-gallery.js owns it and feeds it mobile-specific
 * options (page dots) that the raw data-flickity attribute doesn't carry.
 */
function declarativeSliderElements(scope) {
  const root = scope && scope.querySelectorAll ? scope : document;
  return Array.from(root.querySelectorAll('[data-flickity], [data-flickity-responsive]')).filter(
    (el) => !el.closest('[id^="MediaGallery-"]')
  );
}

function initDeclarativeSliders(scope) {
  if (typeof Flickity === 'undefined') return;

  declarativeSliderElements(scope).forEach((el) => {
    if (Flickity.data(el)) return;

    const responsive = el.getAttribute('data-flickity-responsive');
    if (responsive !== null && typeof FlickityResponsive !== 'undefined') {
      try {
        new FlickityResponsive(el, JSON.parse(responsive || '{}'));
      } catch (error) {
        new FlickityResponsive(el);
      }
      return;
    }

    try {
      new Flickity(el, JSON.parse(el.getAttribute('data-flickity') || '{}'));
    } catch (error) {
      new Flickity(el);
    }
  });
}

function resizeDeclarativeSliders(scope) {
  if (typeof Flickity === 'undefined') return;
  declarativeSliderElements(scope).forEach((el) => {
    const flkty = Flickity.data(el);
    if (flkty) flkty.resize();
  });
}

window.addEventListener('load', () => {
  initDeclarativeSliders(document);
  resizeDeclarativeSliders(document);
});

['shopify:section:load', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder'].forEach(
  (eventName) => {
    document.addEventListener(eventName, (event) => {
      const scope = event.target && event.target.querySelectorAll ? event.target : document;
      initDeclarativeSliders(scope);
      resizeDeclarativeSliders(scope);
    });
  }
);

// Product card image slider: Flickity renders BOTH page dots and prev/next arrows on every
// viewport. CSS (component-card.css) then shows the arrows on desktop and the dots on mobile.
// matatCapCardSliderDots keeps the visible dot count at 3 (CSS hides the 4th+) and maps the
// active image onto one of those 3 dots (start / middle / end) so the active dot is always shown.
function matatCapCardSliderDots(flkty){
  if(!flkty || !flkty.element) return;
  var dots = flkty.element.querySelectorAll('.flickity-page-dots .dot');
  if(!dots.length) return;
  var count = flkty.slides ? flkty.slides.length : dots.length;
  var active = count <= 1 ? 0 : Math.round((flkty.selectedIndex / (count - 1)) * 2);
  if(active < 0) active = 0;
  if(active > 2) active = 2;
  dots.forEach(function(dot, i){ dot.classList.toggle('is-selected', i === active); });
}
window.matatCapCardSliderDots = matatCapCardSliderDots;
document.addEventListener("DOMContentLoaded", (event) => {
  const isHomepage = document.body.classList.contains('index-template-main');
  if(!isHomepage && document.querySelector('.flikity_grid_image')){
        var carousel = document.querySelectorAll('.flikity_grid_image');
        carousel.forEach((slide) => {
            var flkty = new Flickity(slide, {
             "imagesLoaded": true,
              "rightToLeft": true,
              "cellAlign": "right",
              "pageDots": true,
              "wrapAround": true,
              "draggable": true,
              "prevNextButtons": true
          });
            matatCapCardSliderDots(flkty);
            flkty.on('change', function(){ matatCapCardSliderDots(flkty); });
        })
      }
  });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".quick_add_cart .variant-button");
  if (!btn) return;

  const input = btn.querySelector("input.select_color");
  const tooltip = btn.querySelector(".variant-tooltip");

  if (input && tooltip) {
      tooltip.classList.add("show-tooltip"); // your custom class
      // Remove class after 2 seconds
      setTimeout(() => {
          tooltip.classList.remove("show-tooltip");
      }, 2000);
  }
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
      if(this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')){
        this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
          const wrapper = this.closest('.product-card-wrapper') || this.closest('.card-wrapper');
          // Colour-split cards get their media from applyColorToCard(), which copies the exact
          // ALT-matched set the server rendered for that colour. Guessing an image from the
          // variant data here would re-introduce wrong-colour photos: plenty of variants have
          // no image assigned in Shopify, so the previous colour's photo would simply stay put.
          const isColorCard = wrapper && wrapper.dataset.colorCard === 'true';
          const variant_image = isColorCard ? false : this.updateSingleMedia(e.detail);
          swapCardMediaToImage(wrapper, variant_image);

          // Tooltip color change event
          const card = this.closest(".card-wrapper");
          if (card) {
            card.querySelectorAll(".card__content .card-mobile-quickview")
              .forEach(el => el.classList.remove("select_color"));
          }

          // Updating Variant Button
          const variant_details = this.getVariantDetails(e.detail);
          const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
          var $this = this;
          $variant_input.forEach(function(input){
            input.classList.remove('select_color');
            var this_value = input.getAttribute('value');
            switch(input.getAttribute('data-option')) {
              case "1":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option1 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "2":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option2 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "3":
                var condition = variant_details.find((x)=>{
                    return x.available && x.option3 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              default:
            }
          });
        });
      }
    }
    // Product page: warm the colour galleries so switching colour is instant.
    if (this.querySelector('.product-form__input.variation-color-wrapper') && !this.classList.contains('variant-product-card')) {
      this.primeGalleryCache();
    }

    if(this.querySelector(".custom-select")){
      this.querySelectorAll(".custom-select .custom-selected").forEach((select_opt) => {
        select_opt.addEventListener("click", (e) => {
            e.target.nextElementSibling.classList.toggle("active");
        })
      })
      this.querySelectorAll(".custom-select .custom-select-options div").forEach((opt) => {
        opt.addEventListener("click", (optval) => {
          this.querySelectorAll(".custom-select .custom-select-options div").forEach((optremove) => {
            optremove.classList.remove("selected_val");
          });
          let $optvalue = optval.target.innerHTML;
          optval.target.closest(".custom-select").querySelector(".custom-selected span").innerHTML = $optvalue;
          optval.target.closest(".custom-select-options").classList.remove("active");
          optval.target.classList.add("selected_val");
          // change real select option
          let $s = optval.target.closest(".product-form__input--dropdown").getElementsByTagName("select")[0];
          let $sl = $s.length;
          for (let i = 0; i < $sl; i++) {
            if ($s.options[i].innerHTML == $optvalue) {
              $s.options[i].selected = true;
              $s.dispatchEvent(new Event("change", { bubbles: true }));
              break;
            }
          }
        })    
      })
    }
  }

  updateVariantButton(condition, input){
    if(condition){
      input.classList.remove('disabled')
    }else{
      input.classList.add('disabled')
    }
  }

  onVariantChange(e) {
    const fieldset = e.target.querySelectorAll('fieldset');
    let checked_count = 0;
    fieldset.forEach((item)=>{
      if(item.querySelectorAll('input[type="radio"]:checked').length > 0) {
        checked_count++;
      }
    })
    if(checked_count < fieldset.length ) return;
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
        }
        this.quickAddToCart();
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      
      if(e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
        // Prefetched colour? Swap the whole gallery now — main image AND thumbnails together,
        // with no request. Only fall back to nudging the single main image (which leaves the
        // thumbnails lagging until renderProductInfo's fetch lands) when the cache is cold.
        if (!this.swapGalleryFromCache(e.target.value)) {
          this.slideToSelectedVariant(e.target.value);
        }
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  quickAddToCart() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      let enabledCounter = 0;
      const variant_form = this.querySelector('product-form').querySelector('form');

    inputWrappers.forEach((option, index) => {
      const selectedOptionInput = option.querySelector(':checked');
      if(selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
        enabledCounter++;
        if(enabledCounter == inputWrappers.length) {
          variant_form.dispatchEvent(new Event('submit'))
          this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
          this.closest('.product-card-wrapper').classList.add('adding_cart')
        }
      }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia(color) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
    let main_images = [],
        thumb_images = [];

    // Build a meaningful, attribute-safe alt from the selected variant title so
    // gallery images aren't announced as unlabeled to assistive tech / image search.
    const altText = String((this.currentVariant && this.currentVariant.title) || '')
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    for (let img_src of variant_images) {
      const main_classes = ['product__media-item', 'grid__item', 'slider__slide']
      let main_img = document.createElement("li");
      main_img.classList.add(...main_classes);
      main_img.innerHTML = `<a href="${img_src}" data-pswp-width="1000" data-pswp-height="1500">
                    <div class="product-media-container media-type-image media-fit-contain gradient" style="--ratio: 0.6666666666666666; --preview-ratio: 0.6666666666666666;">
                    <div class="product__media media media--transparent has_zoom_element">
                          <img src="${img_src}&amp;width=1946" alt="${altText}">
                        </div>
                    </div>
                  </a>`;
      main_images.push(main_img);

      const thumb_classes = ['thumbnail-list__item', 'slider__slide']
      let thumb_img = document.createElement("li");
      thumb_img.classList.add(...thumb_classes);
      thumb_img.innerHTML = `<button class="thumbnail global-media-settings global-media-settings--no-shadow"><img src="${img_src}&amp;width=416" alt="${altText}"></button>`;
      thumb_images.push(thumb_img);
    }

    const main_product_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.product__media-list[data-flickity]'));
    const main_old_cells = main_product_gallery.cells.map(cell => cell.element);
    if(main_old_cells.length) {
      main_product_gallery.remove(main_old_cells);
    }
    main_product_gallery.insert( main_images, 0 );
    main_product_gallery.select(0);

    // The thumbnail rail is no longer a Flickity instance (native scroll list synced by
    // media-gallery.js), so replace its items directly and let the controller re-bind.
    const thumb_rail = this.closest('.single_main_product_wrapper').querySelector('.thumbnail_slider_side');
    if (thumb_rail) {
      thumb_rail.innerHTML = '';
      thumb_images.forEach((item) => thumb_rail.appendChild(item));
      const mediaGallery = thumb_rail.closest('[id^="MediaGallery-"]');
      if (mediaGallery) {
        delete mediaGallery.dataset.thumbsSynced;
        if (typeof window.initProductMediaGalleries === 'function') {
          window.initProductMediaGalleries(mediaGallery.parentNode || document);
        }
      }
    }
  }

  slideToSelectedVariant(color){
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    // Scope to the nearest product wrapper so this also works inside the quick-view modal
    // (and never targets the wrong gallery when more than one exists on the page).
    const scope = this.closest('.single_main_product_wrapper') || document;
    const variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map((obj) => obj.featured_media.preview_image.src))];
    const target_image = variant_images[0];
    if (!target_image) return;
    // Quick-view modal shows ONLY the first media item (CSS hides the sibling slides), and
    // its Flickity viewer keeps every other cell display:none — so flkty.select() can never
    // reveal the variant's slide. Swap the visible image's src directly instead.
    if (this.closest('quick-add-modal')) {
      const firstItem = scope.querySelector('.product__media-list .product__media-item');
      if (firstItem) {
        const sized = target_image + (target_image.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        const firstImg = firstItem.querySelector('img');
        if (firstImg) {
          firstImg.removeAttribute('srcset');
          firstImg.src = sized;
        }
        // Keep the lightbox anchor (if present) pointing at the variant image too.
        const firstAnchor = firstItem.querySelector('a[href]');
        if (firstAnchor) firstAnchor.setAttribute('href', target_image);
      }
      return;
    }
    // Match by file name only (ignore host/path prefix, query params AND extension):
    // variant JSON uses cdn.shopify.com/s/files/... while gallery media renders as
    // <shop-domain>/cdn/shop/files/..., so comparing full paths never matches.
    const normalize = (url) => {
      const path = (url || '').split('?')[0];
      return path.substring(path.lastIndexOf('/') + 1).replace(/\.(jpe?g|png|webp|gif|avif)$/i, '');
    };
    const wantFile = normalize(target_image);
    let targetMediaItem = null;
    scope.querySelectorAll('.product__media-item').forEach((item) => {
      if (targetMediaItem) return;
      const anchor = item.querySelector('a[href]');
      const img = item.querySelector('img');
      const src = anchor ? anchor.getAttribute('href') : img ? img.getAttribute('src') : '';
      if (normalize(src) === wantFile) targetMediaItem = item;
    });
    const gallery = scope.querySelector('.product-slider-gallery.Product_main_slider');
    const flkty = gallery && typeof Flickity !== 'undefined' ? Flickity.data(gallery) : null;
    // Look the slide up in Flickity's own cell order instead of trusting the
    // server-rendered data-index attribute, which can drift from the real order.
    const cellIndex = flkty && targetMediaItem ? flkty.getCellElements().indexOf(targetMediaItem) : -1;
    if (flkty && cellIndex > -1) {
      // Full product page: slide the Flickity gallery to the variant image.
      flkty.select(cellIndex);
    } else if (!flkty) {
      // Compact quick view (no Flickity slider): swap the first visible media image to the variant image.
      const firstImg = scope.querySelector('.product__media-list .product__media-item img');
      if (firstImg) {
        const sized = target_image + (target_image.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        firstImg.removeAttribute('srcset');
        firstImg.src = sized;
      }
    }
  }

  /**
   * Colour-scoped product gallery.
   *
   * 'product-media-gallery.liquid' renders only the media belonging to the selected colour
   * (linked by the colour appended to each image's ALT tag). On colour change we reuse the
   * section HTML that renderProductInfo() has already fetched and swap the slides in, so no
   * extra request is made.
   *
   * The #Slider-Gallery / #Slider-Thumbnails elements are kept and only their children are
   * replaced — PhotoSwipe binds its click handler to the gallery element itself and resolves
   * the `<a>` children at click time, so the lightbox keeps working across swaps.
   */
  updateColorGallery(html) {
    if (typeof Flickity === 'undefined' || !html) return;

    const sectionId = this.dataset.section;
    const originalSectionId = this.dataset.originalSection || sectionId;
    // Quick view copies the section's inner HTML, so `.single_main_product_wrapper` is absent there.
    const scope =
      this.closest('.single_main_product_wrapper') ||
      this.closest('.quick-add-modal__content-info') ||
      this.closest('quick-add-modal') ||
      document;
    const isRewritten = sectionId !== originalSectionId;

    // Quick view rewrites every section id to `quickadd-<id>`, so map ids in both directions.
    const toSourceId = (destId) => (isRewritten ? destId.split(sectionId).join(originalSectionId) : destId);
    const rewrite = (markup) => (isRewritten ? markup.split(originalSectionId).join(sectionId) : markup);

    const reinitFlickity = (element) => {
      const existing = Flickity.data(element);
      if (existing) existing.destroy();
      // Mobile keeps its page dots; desktop takes the data-flickity config.
      const options = productGalleryFlickityOptions(element);
      if (!options) return;
      new Flickity(element, options);
    };

    scope.querySelectorAll('[id^="Slider-Gallery-"]').forEach((destGallery) => {
      const sourceGallery = html.getElementById(toSourceId(destGallery.id));
      if (!sourceGallery) return;

      // Only rebuild when the colour actually changed; a size-only change must not reset the slider.
      if (destGallery.dataset.galleryColor === sourceGallery.dataset.galleryColor) return;

      const destThumbsId = destGallery.id.replace('Slider-Gallery-', 'Slider-Thumbnails-');
      const destWrapperId = destGallery.id.replace('Slider-Gallery-', 'GalleryThumbnails-');
      const destThumbs = scope.querySelector(`[id="${destThumbsId}"]`);
      const destWrapper = scope.querySelector(`[id="${destWrapperId}"]`);
      const sourceThumbs = html.getElementById(toSourceId(destThumbsId));
      const sourceWrapper = html.getElementById(toSourceId(destWrapperId));

      // Main slider: swap slides, keeping the element (and its lightbox binding) in place.
      const mainFlickity = Flickity.data(destGallery);
      if (mainFlickity) mainFlickity.destroy();
      destGallery.innerHTML = rewrite(sourceGallery.innerHTML);
      destGallery.className = sourceGallery.className;
      destGallery.dataset.galleryColor = sourceGallery.dataset.galleryColor || '';

      // Thumbnails: the track only exists while the colour has more than one image.
      if (destThumbs && sourceThumbs) {
        destThumbs.innerHTML = rewrite(sourceThumbs.innerHTML);
        destThumbs.className = sourceThumbs.className;
      } else if (destWrapper && !sourceWrapper) {
        destWrapper.remove();
      } else if (!destWrapper && sourceWrapper) {
        const viewer = destGallery.closest('[id^="GalleryViewer-"]') || destGallery;
        viewer.insertAdjacentHTML('afterend', rewrite(sourceWrapper.outerHTML));
      }

      reinitFlickity(destGallery);

      // The thumbnail rail is a native scroll list, not a Flickity instance: re-bind its
      // click handlers and active-state sync against the rebuilt viewer (media-gallery.js).
      const mediaGallery = destGallery.closest('[id^="MediaGallery-"]');
      if (mediaGallery) {
        delete mediaGallery.dataset.thumbsSynced;
        if (typeof window.initProductMediaGalleries === 'function') {
          window.initProductMediaGalleries(mediaGallery.parentNode || document);
        }
      }
    });
  }

  /**
   * Colour-gallery prefetch.
   *
   * The gallery is rendered per colour by the server, so switching colour needs that colour's
   * section HTML. Fetching it at click time is what leaves the thumbnail rail trailing behind
   * the main image. Instead every colour is fetched up front — on pointer-enter of a swatch, and
   * again on idle for the rest — so by the time a swatch is clicked the markup is already in
   * memory and the swap is synchronous.
   */
  primeGalleryCache() {
    this._galleryCache = new Map();
    this._galleryPending = new Set();

    const inputs = Array.from(this.querySelectorAll('.product-form__input.variation-color-wrapper input[type="radio"]'));
    if (!inputs.length) return;

    // Hovering or tabbing to a swatch is the earliest reliable signal of intent.
    inputs.forEach((input) => {
      const warm = () => this.fetchGalleryForColor(input.value);
      const label = input.closest('label') || input;
      label.addEventListener('pointerenter', warm, { once: true });
      input.addEventListener('focus', warm, { once: true });
    });

    // Then quietly fill in every colour, one at a time so we never flood the connection. The
    // colour that is selected on load is included too — otherwise switching away and back to it
    // would be the one slow transition left.
    const queue = inputs.map((input) => input.value);
    const drain = () => {
      const next = queue.shift();
      if (next === undefined) return;
      this.fetchGalleryForColor(next).finally(() => setTimeout(drain, 120));
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(drain, { timeout: 3000 });
    } else {
      setTimeout(drain, 1200);
    }
  }

  fetchGalleryForColor(color) {
    if (!color || !this._galleryCache) return Promise.resolve(null);
    const key = color.toLowerCase();
    if (this._galleryCache.has(key) || this._galleryPending.has(key)) return Promise.resolve(null);

    const variant = this.getVariantDetails(color)[0];
    if (!variant) return Promise.resolve(null);

    const sectionId = this.dataset.originalSection || this.dataset.section;
    this._galleryPending.add(key);
    return fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        this._galleryCache.set(key, new DOMParser().parseFromString(text, 'text/html'));
      })
      .catch(() => {
        // Network hiccup — the click-time fetch in renderProductInfo still covers us.
      })
      .finally(() => {
        this._galleryPending.delete(key);
      });
  }

  /** Swap the gallery straight from the cache. Returns false when this colour isn't cached yet. */
  swapGalleryFromCache(color) {
    if (!color || !this._galleryCache) return false;
    const cached = this._galleryCache.get(color.toLowerCase());
    if (!cached) return false;
    this.updateColorGallery(cached);
    return true;
  }

  updateSingleMedia(color) {
    const matches = this.getVariantDetails(color);
    // Prefer a variant of this colour that actually carries an image.
    const single_variant_data =
      matches.find((variant) => (variant.featured_media && variant.featured_media.preview_image) || variant.featured_image) ||
      matches[0];
    if (!single_variant_data) return false;
    // Prefer featured_media.preview_image.src (reliably populated, like the sibling media helpers);
    // fall back to featured_image.src for variants where only an image is bound.
    if (single_variant_data.featured_media && single_variant_data.featured_media.preview_image) {
      return single_variant_data.featured_media.preview_image.src;
    }
    return single_variant_data.featured_image ? single_variant_data.featured_image.src : false;
  }

  /**
   * Which `optionN` key holds the colour.
   *
   * Taken from the fieldset order, which mirrors product.options_with_values, so it is exact.
   * Falls back to probing the variant data for the value when the colour fieldset isn't marked.
   */
  colorOptionKey(color) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset.product-form__input'));
    const index = fieldsets.findIndex(
      (fs) => fs.classList.contains('listen_color_change') || fs.classList.contains('variation-color-wrapper')
    );
    if (index !== -1) return `option${index + 1}`;
    return ['option1', 'option2', 'option3'].find((key) =>
      this.getVariantData().some((variant) => variant[key] === color)
    ) || 'option1';
  }

  /**
   * Variants of exactly this colour.
   *
   * Matching on the option value rather than `title.includes(color)` matters: whenever one
   * colour name is a substring of another ("חום" inside "חום בהיר", "בז'" inside "בז' כהה")
   * the substring test returns the wrong colour's variants.
   */
  getVariantDetails(color) {
    const key = this.colorOptionKey(color);
    const exact = this.getVariantData().filter((variant) => variant[key] === color);
    // A product whose colour option isn't where the fieldsets say it is still resolves through
    // the previous loose match, so nothing regresses on unusual option layouts.
    return exact.length ? exact : this.getVariantData().filter((data) => data.title.includes(color));
  }

  updateURL() {
    const product_card = this.closest('.product-card_inline-variation');
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
    } else {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        if(document.querySelector(".product--giftcard")){
          document.querySelector(".product--giftcard").querySelectorAll(".price__container .price__regular .price-item--regular").forEach((e) =>{
            e.innerHTML = this.currentVariant.title;
          })
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // Price (incl. compare-at / on-sale state) is refreshed wholesale from the
      // server-rendered section in renderProductInfo(), which formats money correctly
      // and updates every price block — no manual main-price-only patch here.
    }
  }

  updateVariantStatuses() {
    const product_card = this.closest('.product-card_inline-variation');
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      if(inputWrappers[index - 1].querySelector(':checked')){
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
         const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
        if(product_card && option.classList.contains('visually-hidden')) {
          product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
          const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
          this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    const product_card = this.closest('.product-card_inline-variation');

    if (!section || product_card) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const product_card = this.closest('.product-card_inline-variation');

    if(product_card) {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const raw_html = new DOMParser().parseFromString(responseText, 'text/html');
        const html = raw_html.querySelector('.single_main_product_wrapper');

        const addButtonUpdated = html.querySelector('.product-form__buttons .product-form__submit');
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        // Refresh the card price (incl. compare-at / on-sale state) from the freshly rendered product page.
        const sourcePrice = html ? html.querySelector('.price') : null;
        const cardWrapper = this.closest('.product-card-wrapper');
        const cardPrice = cardWrapper ? cardWrapper.querySelector('.card__information .price') : null;
        if (sourcePrice && cardPrice) {
          cardPrice.innerHTML = sourcePrice.innerHTML;
          cardPrice.classList.toggle('price--on-sale', sourcePrice.classList.contains('price--on-sale'));
          cardPrice.classList.toggle('price--sold-out', sourcePrice.classList.contains('price--sold-out'));
        }

        // Keep the card's sale badge (percent off) in sync with the selected variant.
        const sourceSaleBadge = html ? html.querySelector('.badge-main-matat .badge-matat.sale') : null;
        const cardSaleBadge = cardWrapper ? cardWrapper.querySelector('.badge-main-matat .badge-matat.sale') : null;
        if (sourceSaleBadge && cardSaleBadge) {
          const badgeOnSale = sourceSaleBadge.classList.contains('is-sale');
          cardSaleBadge.textContent = sourceSaleBadge.textContent.trim();
          cardSaleBadge.classList.toggle('is-sale', badgeOnSale);
          cardSaleBadge.style.display = badgeOnSale ? '' : 'none';
        }

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    } else {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        // The product page renders two price blocks sharing this id (a hidden quick-view
        // header + the visible price block). getElementById would only refresh the first
        // (hidden) one, leaving the visible compare-at price stale on variant change, so
        // update every matching block.
        const priceDestinations = document.querySelectorAll(`#price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source) priceDestinations.forEach((destination) => { destination.innerHTML = source.innerHTML; });
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        priceDestinations.forEach((price) => price.classList.remove('visibility-hidden'));

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        // Show only the selected colour's images (no-ops when the colour didn't change).
        this.updateColorGallery(html);

        // Refresh the sale / sold-out badge (incl. percent off) from the freshly rendered
        // section, so the discount matches the selected variant instead of the product-wide max.
        const sourceBadge = html.querySelector('.badge-main-matat');
        if (sourceBadge) {
          const badgeScope = this.closest('.single_main_product_wrapper') || document;
          badgeScope.querySelectorAll('.badge-main-matat').forEach((badge) => {
            badge.innerHTML = sourceBadge.innerHTML;
          });
        }
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "inline-block";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.add("active");
          addButton.classList.add("hidden");
          addButton.closest(".product-form-main-container-outer").classList.add("backinstock-active-main");
          addButton.closest("product-form").classList.add("backinstock-active");
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "none";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.remove("active");
          addButton.classList.remove("hidden");
          addButton.closest(".product-form-main-container-outer").classList.remove("backinstock-active-main");
          addButton.closest("product-form").classList.remove("backinstock-active");
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const prices = document.querySelectorAll(`#price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    prices.forEach((price) => price.classList.add('visibility-hidden'));
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if(xx){
        if(xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")){
            xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
          }
        return xx.value;
      }else{
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
          return;
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
          this.initSliders();
          this.initQuickViewButtons();
        }

      } catch (e) {
        console.error(e);
      }
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  initSliders() {
    const container = this.querySelector('#recomendation');
    if (!container) return;

    const productItems = container.querySelectorAll('.grid__item');
    const isMobile = window.innerWidth < 990;
    const isDesktop = window.innerWidth >= 990;

    // Main recommendation slider
    if (productItems.length > 0) {
      new Flickity(container, {
        rightToLeft: true,
        cellAlign: 'right',
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        wrapAround: isDesktop, // infinite only on desktop
      });
    }

    // Nested image sliders
    container.querySelectorAll(".enable_image_slider .flickity_grid").forEach(elementItem => {
      const innerItems = elementItem.querySelectorAll('.grid__item');
      if (innerItems.length > 0) {
        new Flickity(elementItem, {
          imagesLoaded: true,
          rightToLeft: true,
          cellAlign: 'right',
          pageDots: false,
          contain: true,
          wrapAround: false, // always false for inner sliders
        });
      }
    });
  }

  initQuickViewButtons() {
    const quickViewButtons = this.querySelectorAll(".mobile-quickview");
    quickViewButtons.forEach(button => {
      button.addEventListener("click", (evt) => {
        const cardWrapper = evt.target.closest(".card-wrapper");
        if (!cardWrapper) return;

        // Trigger quick-add
        cardWrapper.querySelector(".quick-add__submit")?.click();

        const variantRadios = cardWrapper.querySelectorAll(".product-card_inline-variation input[name='מידה']");
        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
        if (!mobilePopupElement || variantRadios.length === 0) return;

        const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
        if (!variationContainer) return;

        mobilePopupElement.classList.add("active");
        variationContainer.innerHTML = Array.from(variantRadios).map(input => {
          const disabledClass = input.classList.contains("disabled") ? "disabled" : "";
          return `<button type="button" value="${input.id}" class="mobile-popup-variant select_color" ${disabledClass}>${input.value}</button>`;
        }).join("");
      });
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

if(window.innerWidth < 750){
  if(!document.querySelector(".gift-card-single-main-product")){
    if(document.querySelector(".single_main_product_wrapper")){
      var flkty = new Flickity( '.product__media-list.contains-media', {
        "imagesLoaded": true,
        "rightToLeft":true,
        "cellAlign":"right",
        "pageDots": true,
        "prevNextButtons": false,
        "wrapAround": true
    });
    }
  }
}

// Zoom button: open the PhotoSwipe lightbox for the currently selected gallery slide.
// Scoped to each button's own gallery so the duplicate (desktop) gallery opens correctly,
// runs on all viewports, and guards against a missing slide so it never throws.
document.querySelectorAll(".matat-mobile-zoom-btn").forEach((zoomBtn) => {
  zoomBtn.addEventListener("click", () => {
    const gallery = zoomBtn.closest(".product__media-wrapper") || document;
    const selectedSlide =
      gallery.querySelector(".product__media-item.is-selected") ||
      gallery.querySelector(".product__media-item.is-active") ||
      gallery.querySelector(".product__media-item");
    const trigger =
      selectedSlide &&
      (selectedSlide.querySelector("a[data-pswp-width]") || selectedSlide.querySelector("img"));
    if (trigger) trigger.click();
  });
});
  
if(document.querySelector(".backinstock_feature_enable")){

  // backin stock feature for product page
if(document.querySelector(".single-main-product-page")){
  function validatePhoneNumber() {
    // Get and trim phone number input
    const phoneNumber = document.getElementById('stock-phone').value.trim();

    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }
  document.getElementById('stock-phone').addEventListener("keyup", (e)=>{
    let phone_value = e.target.value;
    if(phone_value != ""){
      validatePhoneNumber()
    }else{
      document.getElementById('phoneValidationMsg').textContent = "";
    }
  });
  document.querySelector(".matat-stock-notify-submit").addEventListener("click", ()=> {
  document.getElementById('phoneValidationMsg').textContent = '';  
  let check_phone = validatePhoneNumber();
  if (check_phone) {
              // Get data attributes from the button
              const button = document.querySelector(".matat-stock-notify-submit");
              const data = {
                  phone: document.getElementById("stock-phone").value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: button.getAttribute("data-id"),
                  product_id: button.getAttribute("data-product_id"),
                  action: button.getAttribute("data-action"),
                  title: (button.getAttribute("data-title")),
                  price_varies: JSON.parse(button.getAttribute("data-price_varies")),
                  price: (button.getAttribute("data-price")),
                  price_max: (button.getAttribute("data-price_max")),
                  price_min: (button.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
                  src: button.getAttribute("data-src"),
                  url: button.getAttribute("data-url"),
                  user_id: button.getAttribute("data-user_id"),
                  email: button.getAttribute("data-email"),
                  full_name: button.getAttribute("data-full_name"),
                  variant_id: button.getAttribute("data-variant-id"),
                  variant_title: button.getAttribute("data-variant-title")
              };

              fetch(`/apps/text-me/restock-notifications`, {
                  method: 'POST', 
                  headers: {
                    "Content-Type": "application/json",
                    "x-shopify-shop-domain": Shopify.shop
                },
                body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('phoneValidationMsg').style.color = "green"
                document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';  
              })
              .catch(error => {
                  console.error('Error:', error);
              });
  } else {
      document.getElementById('phoneValidationMsg').textContent = "'מספר טלפון לא תקין.";
  }
  })
  document.querySelector('[name="id"]').addEventListener("change",(e)=>{
    let variant_change_val = e.target.value;
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id",variant_change_val);
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-id",variant_change_val);
  })
}
// collection page back in stack
class BackinStockmatat extends HTMLElement{
  constructor() {
  super();
  this.addEventListener("click", () => {
    document.querySelector(".matat-product-card-stock").classList.toggle("active");
    document.body.classList.toggle("overflow-hidden");
    let $AllAttributes = this.attributes;
    this.copyAttributes($AllAttributes);
  })
}

copyAttributes(att){
  [...att].forEach((name) => {
    if(name.nodeName != "class"){
      document.querySelector("matat-stock-popup").setAttribute(name.nodeName,name.nodeValue);
    }
  })
}

}
customElements.define('matat-stock', BackinStockmatat);

// stock popup js starts from here
class matatStockPopup extends HTMLElement{
  constructor() {
    super();
    this.close = this.querySelector(".close-stock-popup");
    this.button = this.querySelector(".stock-popup-button");
    this.input = this.querySelector("#stock-phone-popup");
    this.close.addEventListener("click", () => {
      this.closest(".matat-product-card-stock").classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    })
    this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
    })
    this.addEventListener("click", (evt) => {
      if(evt.target == this){
        this.closest(".matat-product-card-stock").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      }
    })
  }

  validatePhoneNumber(number) {
    // Get and trim phone number input
    const phoneNumber = number.trim();
    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  submitStock(ele){
  document.getElementById('popup_phoneValidation').textContent = '';   
  let check_phone = this.validatePhoneNumber(this.input.value);
  if (check_phone) {
              // Get data attributes from the button
              const datas = this;
              const data = {
                  phone: this.input.value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: datas.getAttribute("data-id"),
                  product_id: datas.getAttribute("data-product_id"),
                  action: datas.getAttribute("data-action"),
                  title: (datas.getAttribute("data-title")),
                  price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
                  price: (datas.getAttribute("data-price")),
                  price_max: (datas.getAttribute("data-price_max")),
                  price_min: (datas.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
                  src: datas.getAttribute("data-src"),
                  url: datas.getAttribute("data-url"),
                  user_id: datas.getAttribute("data-user_id"),
                  email: datas.getAttribute("data-email"),
                  full_name: datas.getAttribute("data-full_name"),
                  variant_id: datas.getAttribute("data-variant-id"),
                  variant_title: datas.getAttribute("data-variant-title")
              };

              fetch('/apps/text-me/restock-notifications', {
                  method: 'POST', 
                  headers: {
                      'Content-Type': 'application/json',
                      "x-shopify-shop-domain": Shopify.shop
                  },
                  body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      document.getElementById('popup_phoneValidation').textContent = "תגובת הרשת לא הייתה בסדר";
                      setTimeout(function(){
                        document.querySelector(".matat-product-card-stock").classList.remove("active");
                        document.body.classList.remove("overflow-hidden");
                      }, 500);  
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('popup_phoneValidation').classList.add("sucess");
                this.displaySuccessMessage("אנו נחזור אליך בהקדם האפשרי, תודה ששלחת");
                document.getElementById('popup_phoneValidation').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
                setTimeout(function(){
                  document.querySelector(".matat-product-card-stock").classList.remove("active");
                  document.body.classList.remove("overflow-hidden");
                }, 200);  
                
              })
              .catch(error => {
                  console.error('Error:', error);
              });
      } else {
        document.getElementById('popup_phoneValidation').classList.remove("sucess");
          document.getElementById('popup_phoneValidation').textContent = "מספר טלפון לא תקין.";
      }
  }
  displaySuccessMessage(message) {
    this.displayAlertMessage(message, "success");
  }
  displayAlertMessage(message, type = "error") {
    const alertBox = document.createElement("div");
    alertBox.classList.add("alert-box", type);
    alertBox.textContent = message;

    document.body.appendChild(alertBox);

    setTimeout(() => {
        alertBox.remove();
    }, 5000); // Remove after 5 seconds
  } 
}
customElements.define('matat-stock-popup', matatStockPopup);

}


const toggleFocusClass = (e) => {
  if(e.target.closest(".floating_input_wrap")){
    e.target.closest(".floating_input_wrap").classList.toggle("focused", e.type === "focus");
  }
  if(e.type == "blur" && e.target.value != ""){
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.add("populated");
    }
  }else{
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.remove("populated");
    }
    
  }
};
document.querySelectorAll(".form-control").forEach((evt) => {
  evt.addEventListener("focus", toggleFocusClass);
  evt.addEventListener("blur", toggleFocusClass);
})
class GoogleLoginBtn extends HTMLElement{
  constructor() {
    super();
    this.querySelector(".google-button").addEventListener('click', () => {
      document.querySelector("#google-login").click();
    })
  }

}
customElements.define('button-google', GoogleLoginBtn);
document.addEventListener("click", (e) =>{
  if(e.target.classList.contains("modal-overlay") && e.target.closest("details").hasAttribute("open")){
      e.target.closest("details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
  }
  if(e.target.classList.contains("extra_color_button")){
    e.target.style.display = "none";
    e.target.closest(".card-variation-color").querySelectorAll(".color-hide-plus").forEach((ele) => {
      ele.classList.remove("color-hide-plus")
    })
  }

  if(e.target.classList.contains("mobile-popup-variant")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
    let $elementVariant = document.querySelector(`#${e.target.value}`);
    var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        $elementVariant.click();
        $elementVariant.dispatchEvent(evt);
  }
  if(e.target.classList.contains("product-vars-inner-main-popup")){
    e.target.classList.remove("active");
  }
  if(e.target.classList.contains("variant_popup_close_mobile") || e.target.closest(".variant_popup_close_mobile")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
  }
  if(e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")){
      const cardWrapper = e.target.closest(".card-wrapper");
        if (!cardWrapper) return;
        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
        quickAddButton?.click();
        
        const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='size']");
        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
        if(variantRadios){
          if (mobilePopupElement) {
            const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
            if (variationContainer && variantRadios) {
              mobilePopupElement.classList.add("active");
              let sizeVariantsHTML = "";
              cardWrapper.querySelectorAll(".product-card_inline-variation input[name='size']").forEach((input) => {
                const $disableClass = input.classList.contains("disabled") ? "disabled" : "";
                sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
              });
              variationContainer.innerHTML = sizeVariantsHTML;
            }
          }
        }
        else{
           cardWrapper.querySelector(".card__inner .product_quick_add_wrap .default_variant_card input[type='radio']").click();
        }        
    }
})
document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelector(".header-icon-search-mobile").addEventListener("click", ()=>{
    if(document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".section-header").classList.remove("menu-open");
    }else{
      document.querySelector(".section-header").classList.add("menu-open");
    }
    if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet")
    }
   }) 
   if(document.body.classList.contains("product-template")){
    function scrollToTop() {
      window.scrollTo(0, 0);
    }
      scrollToTop()
   }
});


// ========navigation scroll

if(document.querySelector(".announcement-bar-section")){
  let annoucement_bar = document.querySelector(".announcement-bar-section").offsetHeight;
  let header_height = document.querySelector(".shopify-section-group-header-group.section-header").offsetHeight;
  let Total_height = annoucement_bar + header_height;
  let height_REM = Total_height / 10;
  document.querySelector("nav.menu-drawer__navigation").style.height = `calc(100dvh - ${height_REM}rem)`;
}else{

  let header_height = document.querySelector(".shopify-section-group-header-group.section-header").offsetHeight;
  let height_REM = header_height / 10;
  document.querySelector("nav.menu-drawer__navigation").style.height = `calc(100dvh - ${height_REM}rem)`;
}

// Tooltip for mobile add to cart btn 
document.addEventListener("click", (e) => {
  const card = e.target.closest(".card-mobile-quickview.select_color")?.closest(".card-wrapper");
  const tooltip = card?.querySelector(".tooltip_text");
  if (!tooltip) return;

  tooltip.classList.remove("hidden");
  setTimeout(() => tooltip.classList.add("hidden"), 2000);
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.card__inner .variant-button input').forEach(function (input) {
    input.classList.remove('disabled');
  });
});

// START Accessibility settings
// Sliders (Swiper/Flickity) and apps mark off-screen slides with
// aria-hidden="true" but leave their links/buttons focusable, which fails the
// "[aria-hidden] elements contain focusable descendants" audit. Keep focusable
// descendants of any aria-hidden container out of the tab order, and restore
// them once the container is shown again.
(function () {
  var FOCUSABLE =
    'a[href], button, input, select, textarea, iframe, [contenteditable="true"], [tabindex]:not([tabindex="-1"])';

  function syncAriaHiddenFocusables() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(function (container) {
      container.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (!el.hasAttribute('data-a11y-prev-tabindex')) {
          el.setAttribute('data-a11y-prev-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      });
    });

    document.querySelectorAll('[data-a11y-prev-tabindex]').forEach(function (el) {
      if (el.closest('[aria-hidden="true"]')) return;
      var prev = el.getAttribute('data-a11y-prev-tabindex');
      if (prev === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', prev);
      }
      el.removeAttribute('data-a11y-prev-tabindex');
    });
  }

  function init() {
    syncAriaHiddenFocusables();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncAriaHiddenFocusables();
      });
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', syncAriaHiddenFocusables);
})();
// END Accessibility settings

// ─── Search modal max-height + header menu underline height ───────────────────
// Moved out of the inline <script> in theme.liquid so this logic is cached with
// global.js instead of being re-parsed (unminified) on every page load.
(function () {
  function adjustSearchHeight() {
    var searchContent = document.querySelector('.search-modal__content.search-modal__content-bottom');
    if (!searchContent) return;
    var stcky_ele = document.querySelector('sticky-header');
    var topPos = stcky_ele ? stcky_ele.getBoundingClientRect().top : 0;
    var headerHeight = stcky_ele ? stcky_ele.clientHeight : 0;
    searchContent.style.maxHeight = (window.innerHeight - headerHeight - topPos) + 'px';
  }
  var _searchHeightTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(_searchHeightTimer);
    _searchHeightTimer = setTimeout(adjustSearchHeight, 100);
  });
  window.addEventListener('load', adjustSearchHeight);

  // Height of the hover bridge under each top-level menu link, consumed by
  // `.top-level-entry-container > .header__menu-item.list-menu__item:after`.
  // It must span exactly the dead gap between the bottom of the link and the
  // top of the mega-menu panel (the header's bottom padding). Anything larger
  // hangs below the header and turns the area over the page content into an
  // invisible hover target that pops the panel open on its own.
  function setMenuUnderlineHeight() {
    var wrapper = document.querySelector('.header-wrapper');
    var item = document.querySelector('.top-level-entry-container .header__menu-item');
    if (!wrapper || !item) return;
    var gap = wrapper.getBoundingClientRect().bottom - item.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--menu-underline-height', Math.max(0, gap) + 'px');
  }
  setMenuUnderlineHeight();
  window.addEventListener('load', setMenuUnderlineHeight);
  var _underlineTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_underlineTimer);
    _underlineTimer = setTimeout(setMenuUnderlineHeight, 150);
  });
})();

// Floating labels for the contact form. Replaces the jQuery + FlowUp Labels
// plugin (~147KB) with a dependency-free initializer that toggles the same
// `.focused` / `.populated` classes the contact CSS already targets.
(function initFloatingLabels() {
  function init() {
    document.querySelectorAll('.contact-form-holder .form-group').forEach((group) => {
      const field = group.querySelector('.form-control');
      if (!field) return;
      const setPopulated = () =>
        group.classList.toggle('populated', field.value.trim() !== '');
      field.addEventListener('focus', () => group.classList.add('focused'));
      field.addEventListener('blur', () => group.classList.remove('focused'));
      field.addEventListener('input', setPopulated);
      setPopulated();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();